import GameTree from "./gameTree";

class Collection {
  constructor() {
    this.children = []; // games
  }

  get size() {
    return this.children.length;
  }

  addChild(gameTree) {
    if (!(gameTree instanceof GameTree)) {
      throw new TypeError('Not a GameTree');
    }
    this.children.push(gameTree);
    gameTree.parent = this;
    return this;
  }

  insertChild(index, gameTree) {
    if (!(gameTree instanceof GameTree)) {
      throw new TypeError('Not a GameTree');
    } else if (index < 0 || index > this.children.length) {
      throw new RangeError();
    }
    this.children.splice(index, 0, gameTree);
    gameTree.parent = this;
    return this;
  }

  removeChild(gameTree) {
    if (!(gameTree instanceof GameTree)) {
      throw new TypeError('Not a GameTree');
    }
    this.children = this.children.filter(gt => gt !== gameTree);
    gameTree.parent = undefined;
    return this;
  }

  containsChild(gameTree) {
    if (!(gameTree instanceof GameTree)) {
      throw new TypeError('Not a GameTree');
    }
    return this.children.indexOf(gameTree) !== -1;
  }

  hasChild() {
    return this.children.length > 0;
  }

  clear() {
    this.children = [];
  }

  toString() {
    return this.children.reduce((str, game) => str + game, "");
  }
}

export default Collection;